import React from 'react';
import { FormikProps } from 'formik';
import { KeyMatch } from '../../../types';
import InputWrap from './InputWrap';

interface Props<T> extends FormikProps<T> {
  name: KeyMatch<T, string | null>;
  label: string;
  icon?: React.ReactNode;
  type?: string;
  placeholder?: string;
  disabled?: boolean;
}

const TextInput = <T extends object>(props: Props<T>) => {
  const { label, icon } = props;

  const iconDiv = icon === null ? null : <div className="form__form-group-icon">{icon}</div>;

  return (
    <div className="form__form-group">
      <span className="form__form-group-label">{label}</span>
      <div className="form__form-group-field d-block">
        <InputWrap {...props} />
        {iconDiv}
      </div>
    </div>
  );
};

export default TextInput;
